import React from 'react';
import Button from '../../../../bootstrap/Button.jsx';
import Portal from '../../../../common/Portal.jsx';
import { FaIcon } from '../../../../common/Icons.jsx';
import Tooltip from '../../../../common/Tooltip.jsx';
import { useFormulaFields } from '../../../hooks/useFormulaFields.js';
import { useFormulaFieldSettings } from './useFormulaFieldSettings.js';
import { useFormulaDialog } from './useFormulaDialog.js';
import FormulaFieldDialog from './FormulaFieldDialog.jsx';
import styles from './FormulaField.module.scss';

/**
 * Lists the widget's formula fields with edit and delete actions.
 */
function FormulaFieldsSettings({ widgetId }) {
  const { compiledFields } = useFormulaFields(widgetId);
  const { removeFormulaField } = useFormulaFieldSettings(widgetId);
  const { open, editedField, openDialog, closeDialog } = useFormulaDialog();

  const handleRemove = (field) => {
    if (confirm(I18n.t('delete_formula_confirmation', { name: field.name }))) {
      removeFormulaField(field.id);
    }
  };

  return (
    <>
      <p className='description'>{I18n.t('formula_fields_description')}</p>
      {compiledFields.length > 0 && (
        <ul className={styles['formula-field-list']}>
          {compiledFields.map(field => (
            <li key={field.id} className={styles['formula-field-item']}>
              <span className={styles['formula-field-name']}>
                ƒ {field.name}
                {field.compiled.error && (
                  <Tooltip title={field.compiled.error.translate()}>
                    <FaIcon type='exclamation-triangle' className={`ml-1 ${styles['formula-field-error']}`} />
                  </Tooltip>
                )}
              </span>
              <span>
                <Button type='link' size='xs' onClick={() => openDialog(field)} title={I18n.t('edit')}>
                  <FaIcon type='pencil' />
                </Button>
                <Button type='link' size='xs' onClick={() => handleRemove(field)} title={I18n.t('delete')}>
                  <FaIcon type='trash' />
                </Button>
              </span>
            </li>
          ))}
        </ul>
      )}
      <Button type='default' size='sm' onClick={() => openDialog()}>
        <FaIcon type='plus' /> {I18n.t('create_formula')}
      </Button>
      {open && (
        <Portal
          component={FormulaFieldDialog}
          widgetId={widgetId}
          field={editedField}
          closeDialog={closeDialog}
        />
      )}
    </>
  );
}

export default FormulaFieldsSettings;
